<template>
  <!--  <transition appear class="flex-grow-1 question mw-100" name="slide-up" tag="div">-->
  <div v-if="question.isAuthorized()" class="w-100 offers">
    <div
      class="bg-success fs-2 d-flex justify-content-between align-items-center px-5 py-5 text-white fw-bolder rounded mb-5"
    >
      <div>{{ coverages.length }} offres correspondantes</div>
      <div
        class="d-flex gap-2 bg-light-primary px-2 py-2 rounded align-items-center"
      >
        <div
          v-if="workflows.includes('asaci') && hasRole('ROLE_MANAGER')"
          class="d-flex gap-2 rounded align-items-center"
        >
          <div v-if="attestations.blue > 0" class="fw-bolder text-dark">
            <i class="fad fa-file text-primary fs-2"></i>
            {{ attestations.blue }}
          </div>
          <div v-if="attestations.yellow > 0" class="fw-bolder text-dark">
            <i class="fad fa-file text-warning fs-2"></i>
            {{ attestations.yellow }}
          </div>
          <div v-if="attestations.green > 0" class="fw-bolder text-dark">
            <i class="fad fa-file text-success fs-2"></i>
            {{ attestations.green }}
          </div>
        </div>
        <label
          v-if="hasRole('ROLE_MANAGER')"
          class="btn btn-xs btn-icon btn-primary"
        >
          <i class="fad fa-cogs"></i>
          <input
            v-model="showComparisonDetails"
            class="hidden"
            type="checkbox"
          />
        </label>
      </div>
    </div>
    <div :key="'calcul_' + calculUuid">
      <div
        v-if="coverages.length === 0"
        class="d-flex flex-column align-items-center justify-content-center bg-light-warning rounded border-dashed border-warning"
      >
        <div
          class="align-items-center justify-content-center d-flex flex-column"
        >
          <div class="fw-bolder text-gray-400 fs-2 my-10">
            <i class="fad fa-empty-set fs-5x"></i>
          </div>
          <div v-if="!invalid" class="fw-bolder text-gray-400 fs-2 my-10">
            Désolé, aucun produit compatible à vos besoins
            <label
              v-if="hasRole('ROLE_MANAGER')"
              class="btn btn-xs btn-icon btn-primary"
            >
              <i class="fad fa-cogs"></i>
              <input
                v-model="showComparisonDetails"
                class="hidden"
                type="checkbox"
              />
            </label>
          </div>
          <div v-else class="fw-bolder text-gray-400 fs-2 my-10">
            Veuillez renseigner les informations nécessaires à la cotation
            <label
              v-if="hasRole('ROLE_MANAGER')"
              class="btn btn-xs btn-icon btn-primary"
            >
              <i class="fad fa-cogs"></i>
              <input
                v-model="showComparisonDetails"
                class="hidden"
                type="checkbox"
              />
            </label>
          </div>
        </div>
      </div>
      <template v-else>
        <div v-if="branch && !isMobile" class="d-flex w-100 flex-grow-0">
          <div
            v-if="!packSelected"
            class="p-3"
            style="
              position: sticky;
              left: 0;
              top: 0;
              background: white;
              z-index: 2;
            "
          >
            <table class="table-striped gy-2 gs-3 guarantee">
              <thead>
                <tr>
                  <th class="text-center">Garanties</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(guarantee, index) in branch.guarantees">
                  <template v-if="onePackHasGuarantee(guarantee)">
                    <tr>
                      <td class="p-2" style="white-space: nowrap">
                        <div
                          class="d-flex justify-content-between align-items-center"
                          style="width: 17rem; white-space: initial"
                        >
                          {{ guarantee.label }}
                          <i
                            class="fad fa-question-circle ms-2 cursor-pointer"
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
          <div
            id="result-container"
            class="results-container overflow-auto"
            style="flex: 2"
          >
            <div
              v-if="packSelected"
              class="d-flex flex-column align-items-center justify-content-center bg-light-primary py-5"
            >
              <div class="d-flex justify-content-center">
                <div
                  class="justify-content-center align-items-center d-flex flex-column"
                >
                  <div>
                    <img
                      v-if="packSelected.pack.insurer.photo"
                      :alt="packSelected.pack.insurer.label"
                      :src="uploadRoot + packSelected.pack.insurer.photo"
                      class="mh-50px"
                    />
                  </div>
                  <div class="fw-bolder fs-2x ms-5">
                    {{ packSelected.pack.label }}
                    {{ getDuree() ? " / " + getDuree() : "" }}
                  </div>
                  <div
                    v-if="getReductionAmount(packSelected) > 0"
                    class="fs-2x fw-bolder badge badge-light-danger text-decoration-line-through"
                  >
                    {{
                      currency(
                        packSelected.premium + getReductionAmount(packSelected)
                      )
                    }}
                  </div>
                  <div class="fs-3x fw-bolder">
                    {{ currency(packSelected.premium) }}
                  </div>
                </div>
                <div
                  class="ms-5 d-flex flex-column ps-5"
                  style="border-left: 1px gainsboro solid"
                >
                  <template v-for="pg in packSelected.pack.packGuarantees">
                    <div
                      v-if="!pg.isOptional || pg.selected"
                      class="py-2 fw-bolder"
                    >
                      {{ pg.guarantee.label }}
                    </div>
                  </template>
                </div>
              </div>
              <div class="py-5">
                <label
                  v-if="hasRole('ROLE_MANAGER')"
                  class="btn btn-icon btn-primary"
                >
                  <i class="fad fa-cogs"></i>
                  <input
                    v-model="showComparisonDetails"
                    class="hidden"
                    type="checkbox"
                  />
                </label>
                <div
                  v-if="hasRole('ROLE_MANAGER')"
                  class="btn btn-info btn-icon ms-2"
                  @click="showDetails(packSelected)"
                >
                  <i class="fad fa-cog"></i>
                </div>
                <div class="btn btn-danger ms-2" @click="unselect">
                  Modifier
                </div>

                <template
                  v-if="
                    workflows.includes('asaci') && !canSubscribe(packSelected)
                  "
                >
                  <button class="btn btn-light-dark">Rupture de Stock</button>
                </template>
                <template v-else>
                  <div
                    v-if="canSubscribe(packSelected)"
                    class="btn bt-sm btn-warning ms-5"
                    @click="subscribe(packSelected)"
                  >
                    Souscrire
                  </div>
                </template>
              </div>
            </div>
            <div v-else id="scroller" class="w-100 overflow-auto p-3 h-100">
              <Loading v-if="isLoading" />
              <table v-else class="table-striped gy-2 gs-3 ms-5 results">
                <thead>
                  <tr>
                    <template v-for="coverage in coverages">
                      <th
                        :id="'coverage-header-' + coverage.pack.id"
                        class="text-center"
                      >
                        <div>
                          <div class="px-5 text-center">
                            <div class="">
                              <div
                                class="pb-1 fw-bolder"
                                style="white-space: nowrap; height: 50px"
                              >
                                <img
                                  v-if="
                                    coverage.insurer && coverage.insurer.photo
                                  "
                                  :alt="coverage.insurer?.label"
                                  :src="uploadRoot + coverage.insurer.photo"
                                  :title="coverage.insurer?.label"
                                  class="h-50px"
                                />
                              </div>
                              <div class="mt-4">
                                {{ coverage.insurer?.label }}
                              </div>
                              <div></div>
                              <div class="fw-bolder fs-2 text-uppercase">
                                {{ coverage.label }}
                              </div>
                              <div>
                                <div
                                  v-if="
                                    hasRole('ROLE_MANAGER') &&
                                    workflows.includes('asaci')
                                  "
                                  class="d-flex justify-content-center align-items-center px-4 py-4"
                                  style="min-width: 100px"
                                >
                                  <div
                                    v-if="attestations.blue > 0"
                                    class="fw-bolder text-primary"
                                  >
                                    <i
                                      class="fad fa-file text-primary fs-2"
                                    ></i>
                                    {{
                                      certificateRemaining[coverage.insurerId]
                                        ?.blue
                                    }}
                                  </div>
                                  <div
                                    v-if="attestations.yellow > 0"
                                    class="fw-bolder"
                                  >
                                    <i
                                      class="fad fa-file text-warning fs-2"
                                    ></i>
                                    {{
                                      certificateRemaining[coverage.insurerId]
                                        ?.yellow
                                    }}
                                  </div>
                                  <div
                                    v-if="attestations.green > 0"
                                    class="fw-bolder text-success"
                                  >
                                    <i
                                      class="fad fa-file text-success fs-2"
                                    ></i>
                                    {{
                                      certificateRemaining[coverage.insurerId]
                                        ?.green
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div
                                v-if="coverage.reductionAmount"
                                class="fs-2 whitespace-no-wrap text-danger text-decoration-line-through fw-bolder"
                              >
                                {{
                                  helper.currencyFormat(
                                    coverage.premium + coverage.reductionAmount
                                  )
                                }}
                              </div>
                              <div
                                class="fs-2x whitespace-no-wrap text-primary fw-bolder"
                              >
                                {{ helper.currencyFormat(coverage.premium) }}
                              </div>
                              <div class="text-primary fw-bolder">
                                {{ getDuree() ? " / " + getDuree() : "" }}
                              </div>
                              <div>
                                <div
                                  class="d-flex align-items-center justify-content-center mb-2"
                                >
                                  <div
                                    v-if="canSubscribe(coverage)"
                                    class="btn bt-sm btn-warning"
                                    @click="subscribe(coverage)"
                                  >
                                    Souscrire
                                  </div>
                                  <button
                                    v-else
                                    class="btn bt-sm btn-light-dark whitespace-no-wrap"
                                    disabled
                                  >
                                    Rupture de Stock
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(guarantee, index) in branch.guarantees">
                    <tr v-if="onePackHasGuarantee(guarantee)">
                      <template v-for="(coverage, xindex) in coverages">
                        <td
                          :key="coverage.pack.id + '-' + guarantee.id"
                          :class="
                            'p-2 text-center coverage-column-' +
                            coverage.pack.id
                          "
                          :set="(risk = coverage.risks[guarantee.id])"
                          valign="middle"
                        >
                          <template v-if="coverage.risks[guarantee.id]">
                            <div v-if="!risk.isOptional">
                              <i
                                class="fad fa-shield-check text-success fs-2"
                              ></i>
                            </div>
                            <div
                              v-else
                              class="d-flex align-items-center position-relative"
                            >
                              <div class="flex-grow-1">
                                <i
                                  class="fad fa-shield-check text-primary fs-2"
                                ></i>
                              </div>
                              <div
                                class="px-2 cursor-pointer position-absolute btn btn-danger btn-xs btn-icon"
                                style="right: 0"
                                @click.stop.prevent="
                                  toggleOptional(coverage, guarantee)
                                "
                              >
                                <i class="fad fa-times"></i>
                              </div>
                            </div>
                          </template>
                          <template
                            v-else-if="coverage.optionalRisks[guarantee.id]"
                          >
                            <div
                              class="d-flex justify-content-center align-items-center w-100"
                            >
                              <label
                                class="fw-bolder cursor-pointer text-primary text-decoration-underline"
                                @click.stop.prevent="
                                  toggleOptional(coverage, guarantee)
                                "
                              >
                                <input
                                  :key="helper.generateId()"
                                  class="hidden"
                                  type="checkbox"
                                />
                                <i class="fad fa-plus-circle text-primary"></i>
                                {{
                                  helper.currencyFormat(
                                    coverage.optionalRisks[guarantee.id].premium
                                  )
                                }}
                              </label>
                            </div>
                          </template>
                          <template v-else>
                            <i
                              class="fad fa-times-circle fs-2 text-danger"
                              title="Garantie non couverte"
                            ></i>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- VUE MOBILE DES OFFRES.
             Le tableau comparatif ne tient pas sur un telephone : une carte par offre,
             la meme donnee. Ce bloc existait, commente depuis janvier ; comme le tableau
             desktop est en `v-if="!isMobile"`, il ne restait plus rien a afficher sous
             1000 px. Reecrit sur le modele actuel (coverages / risks / optionalRisks),
             l'ancien parlait encore de `results` et n'aurait pas fonctionne. -->
        <div v-if="branch && isMobile" class="mobile-offers">
          <Loading v-if="isLoading" />
          <template v-else>
            <div
              v-for="coverage in coverages"
              :key="'mo_' + coverage.pack.id"
              class="mo-card"
            >
              <div class="mo-head">
                <img
                  v-if="coverage.insurer && coverage.insurer.photo"
                  :src="uploadRoot + coverage.insurer.photo"
                  :alt="coverage.insurer.label"
                  class="mo-logo"
                />
                <div class="mo-ident">
                  <div class="mo-insurer">
                    {{ coverage.insurer ? coverage.insurer.label : "" }}
                  </div>
                  <div class="mo-pack">{{ coverage.label }}</div>
                </div>
                <div
                  v-if="hasRole('ROLE_MANAGER')"
                  class="btn btn-icon btn-light-info btn-sm"
                  @click="showDetails(coverage)"
                >
                  <i class="fad fa-cog"></i>
                </div>
              </div>

              <div class="mo-price">
                <div v-if="coverage.reductionAmount" class="mo-old">
                  {{
                    helper.currencyFormat(
                      coverage.premium + coverage.reductionAmount
                    )
                  }}
                </div>
                <div class="mo-amount">
                  {{ helper.currencyFormat(coverage.premium) }}
                </div>
                <div v-if="getDuree()" class="mo-period">/ {{ getDuree() }}</div>
              </div>

              <!-- Les garanties sont repliees : une quinzaine de lignes par offre,
                   sur une vingtaine d'offres, rendrait la liste illisible. -->
              <div
                class="mo-toggle"
                @click="toggleMobileGuarantees(coverage)"
              >
                <span>
                  {{ countIncluded(coverage) }} garantie(s) incluse(s)
                  <template v-if="countOptional(coverage) > 0">
                    &middot; {{ countOptional(coverage) }} en option
                  </template>
                </span>
                <i
                  class="fad"
                  :class="
                    isMobileGuaranteesOpen(coverage)
                      ? 'fa-chevron-up'
                      : 'fa-chevron-down'
                  "
                ></i>
              </div>

              <div v-if="isMobileGuaranteesOpen(coverage)" class="mo-guarantees">
                <template v-for="guarantee in branch.guarantees">
                  <template v-if="onePackHasGuarantee(guarantee)">
                    <!-- Souscrite : incluse d'office, ou optionnelle deja retenue -->
                    <div
                      v-if="coverage.risks[guarantee.id]"
                      :key="'mg_' + coverage.pack.id + '_' + guarantee.id"
                      class="mo-g mo-g--in"
                    >
                      <i class="fad fa-shield-check"></i>
                      <span class="mo-g-label">{{ guarantee.label }}</span>
                      <span
                        v-if="coverage.risks[guarantee.id].isOptional"
                        class="btn btn-icon btn-light-danger btn-xs"
                        @click.stop.prevent="toggleOptional(coverage, guarantee)"
                      >
                        <i class="fad fa-times"></i>
                      </span>
                      <span v-else class="mo-g-note">Incluse</span>
                    </div>

                    <!-- Disponible en option : le prix est le geste, on le rend cliquable -->
                    <div
                      v-else-if="coverage.optionalRisks[guarantee.id]"
                      :key="'mg_' + coverage.pack.id + '_' + guarantee.id"
                      class="mo-g mo-g--opt"
                      @click.stop.prevent="toggleOptional(coverage, guarantee)"
                    >
                      <i class="fad fa-plus-circle"></i>
                      <span class="mo-g-label">{{ guarantee.label }}</span>
                      <span class="mo-g-price">
                        {{
                          helper.currencyFormat(
                            coverage.optionalRisks[guarantee.id].premium
                          )
                        }}
                      </span>
                    </div>

                    <!-- Non couverte : dite, pas tue -- une garantie absente est une
                         information, l'omettre laisserait croire qu'elle est incluse. -->
                    <div
                      v-else
                      :key="'mg_' + coverage.pack.id + '_' + guarantee.id"
                      class="mo-g mo-g--out"
                    >
                      <i class="fad fa-times-circle"></i>
                      <span class="mo-g-label">{{ guarantee.label }}</span>
                      <span class="mo-g-note">Non couverte</span>
                    </div>
                  </template>
                </template>
              </div>

              <div class="mo-actions">
                <div
                  v-if="canSubscribe(coverage)"
                  class="btn btn-warning w-100"
                  @click="subscribe(coverage)"
                >
                  Souscrire
                </div>
                <button v-else class="btn btn-light-dark w-100" disabled>
                  Rupture de stock
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
    <transition name="slide-left-back">
      <div
        v-if="packDetails && hasRole('ROLE_MANAGER')"
        class="position-fixed bg-white p-5 shadow-lg top-0 h-100 overflow-auto"
        style="right: 0"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h1 class="mb-0">{{ trans("Détails de la cotation") }}</h1>
          <div class="btn btn-danger btn-xs ms-5 btn-icon" @click="hideDetails">
            <i class="fad fa-times"></i>
          </div>
        </div>

        <div class="mt-5">
          <div>
            <img
              :alt="packDetails.pack.insurer.label"
              :src="uploadRoot + packDetails.pack.insurer.photo"
              class="mh-50px"
            />
          </div>
          <div class="my-5 fw-bolder">
            {{ packDetails.pack.insurer.label }} ▪️ {{ packDetails.pack.label }}
          </div>
          <div>
            <table class="table table-striped gx-2">
              <tbody>
                <tr v-for="detail in packDetails.details">
                  <td class="p-2">
                    {{ detail.name }}
                  </td>
                  <td class="text-end p-2">
                    {{ helper.currencyFormat(detail.value) }}
                  </td>
                </tr>

                <tr class="">
                  <td
                    class="bg-danger text-center fw-bolder text-uppercase"
                    colspan="2"
                  >
                    Réductions
                  </td>
                </tr>
                <tr
                  v-for="reduction in packDetails.reductions"
                  class="bg-light-danger"
                >
                  <td class="p-2">
                    {{ reduction.model.label }}
                  </td>
                  <td class="text-end p-2">
                    {{ helper.currencyFormat(reduction.premium) }}
                  </td>
                </tr>

                <tr
                  class="fw-bolder fs-2 bg-light-success text-success text-uppercase"
                >
                  <td>A payer</td>
                  <td>
                    {{
                      helper.currencyFormat(
                        packDetails.premium - getReductionAmount(packDetails)
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="!empty(backendDetails)">
              <h2>Backend</h2>
              <table class="table table-striped">
                <tbody>
                  <tr v-for="detail in backendDetails">
                    <td class="p-2">
                      {{ detail.name }}
                    </td>
                    <td class="text-end p-2">
                      {{ helper.currencyFormat(detail.value) }}
                    </td>
                  </tr>
                  <!--                <tr>-->
                  <!--                  <td colspan="2" class="bg-dark px-5">-->
                  <!--                    Premium Details-->
                  <!--                  </td>-->
                  <!--                </tr>-->
                  <tr v-for="detail in backendPremiumdetails">
                    <td class="p-2">
                      {{ detail.label }}
                    </td>
                    <td class="text-end p-2">
                      {{ helper.currencyFormat(detail.value) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-left-back">
      <div
        v-if="showComparisonDetails && hasRole('ROLE_MANAGER')"
        class="position-fixed bg-white shadow-lg top-0 h-100 overflow-auto d-flex"
        style="right: 0; z-index: 2"
      >
        <div>
          <div class="d-flex justify-content-between align-items-center p-5">
            <h1 class="mb-0">{{ trans("Détails de la comparaison") }}</h1>
            <div class="d-flex align-items-center">
              <button
                class="btn btn-sm ms-5"
                :class="showMappedData ? 'btn-primary' : 'btn-light-primary'"
                :disabled="!engineInput"
                :title="engineInput ? trans('Voir les données envoyées au moteur de calcul') : trans('Lance un calcul pour voir les données mappées')"
                @click="showMappedData = !showMappedData"
              >
                <i class="fad fa-code"></i>
                {{ trans("Données mappées") }}
              </button>
              <div
                class="btn btn-danger btn-xs ms-3 btn-icon"
                @click="showComparisonDetails = false"
              >
                <i class="fad fa-times"></i>
              </div>
            </div>
          </div>

          <!-- Données mappées : ce qui est réellement envoyé au moteur de calcul -->
          <div v-if="showMappedData" class="px-5 pb-5">
            <div
              class="d-flex justify-content-between align-items-center mb-2"
            >
              <span class="text-muted fs-7">
                <i class="fad fa-circle-info me-1"></i>
                {{ trans("items + payload transmis au moteur (computeVehicle)") }}
              </span>
              <button
                class="btn btn-sm btn-light-primary"
                :disabled="!engineInput"
                @click="copyMappedData"
              >
                <i class="fad" :class="mappedCopied ? 'fa-check' : 'fa-copy'"></i>
                {{ mappedCopied ? trans("Copié") : trans("Copier") }}
              </button>
            </div>
            <engine-input-debugger v-if="engineInput" :value="engineInput"></engine-input-debugger>
            <div v-else class="text-muted fst-italic">
              {{ trans("Aucun calcul effectué pour le moment.") }}
            </div>
          </div>

          <div class="">
            <template v-for="(insurer, insurerIndex) in insurers">
              <div
                v-if="debug[insurer.id]"
                :key="'debug-insurer-' + insurer.id"
                style="
                  border-top: 1px whitesmoke solid;
                  border-bottom: 1px whitesmoke solid;
                "
              >
                <input
                  :id="'insurer-accordion-' + insurer.id"
                  :name="'insurer-accordion-' + insurer.id"
                  class="checkbox-accordion"
                  type="checkbox"
                />
                <label
                  :for="'insurer-accordion-' + insurer.id"
                  class="fw-bolder py-2 px-5 w-100 cursor-pointer bg-hover-light-primary d-flex justify-content-between"
                >
                  <span>
                    <i class="fad fa-caret-right me-1"></i>
                    <i class="fad fa-caret-down me-1"></i>
                    {{ insurer.label }}
                  </span>
                  <span>
                    <i
                      v-if="!insurer.active"
                      class="fad fa-exclamation-triangle text-danger"
                      title="Désactivé"
                    ></i>
                  </span>
                </label>
                <div class="accordion">
                  <template v-for="pack in insurer.packs">
                    <div
                      v-if="debug[insurer.id][pack.id]"
                      :key="'debug-pack-' + pack.id"
                    >
                      <label
                        :for="'pack-accordion-' + pack.id"
                        class="fw-bolder py-1 w-100 px-5 ps-10 cursor-pointer bg-hover-light-primary d-flex justify-content-between"
                      >
                        <span>
                          <i class="fad fa-caret-right me-1"></i>
                          {{ pack.label }}
                        </span>
                        <span>
                          {{ currency(debug[insurer.id][pack.id].premium) }}
                          <i
                            v-if="!pack.enable"
                            class="fad fa-exclamation-triangle text-danger"
                            title="Désactivé"
                          ></i>
                        </span>
                      </label>
                      <input
                        :id="'pack-accordion-' + pack.id"
                        :name="'pack-accordion-' + pack.id"
                        class="checkbox-accordion"
                        type="checkbox"
                      />
                      <div class="accordion ps-15">
                        <table class="table m-0 table-stripped">
                          <template
                            v-for="detail in debug[insurer.id][pack.id].details"
                          >
                            <tr
                              class="fw-bolder py-1 cursor-pointer bg-hover-light-primary"
                              @click="debugDetails(detail)"
                            >
                              <td class="py-1 px-5">
                                <span :style="detail.error ? 'color:#f1416c' : ''">{{ detail.name }}</span> {{ detail.isReduction }}
                                <span v-if="detail.error" class="badge badge-light-danger ms-2"><i class="fad fa-triangle-exclamation me-1"></i>erreur</span>
                              </td>
                              <td
                                class="text-end px-5"
                                style="text-align: right; padding-left: 100px"
                              >
                                {{ currency(detail.value) }}
                              </td>
                              <td class="text-end px-3" style="width:40px">
                                <router-link
                                  v-if="methodLink(detail)"
                                  :to="methodLink(detail)"
                                  target="_blank"
                                  class="btn btn-icon btn-xs btn-light-primary"
                                  title="Ouvrir la fonction dans un nouvel onglet"
                                  @click.native.stop
                                >
                                  <i class="fad fa-arrow-up-right-from-square fs-9"></i>
                                </router-link>
                              </td>
                            </tr>
                          </template>
                        </table>
                      </div>
                      <div
                        v-if="debug[insurer.id][pack.id].errors && debug[insurer.id][pack.id].errors.length"
                        class="ps-15"
                      >
                        <div
                          v-for="(err, ei) in debug[insurer.id][pack.id].errors"
                          :key="'err-' + pack.id + '-' + ei"
                          class="alert alert-danger py-2 px-3 my-2"
                          style="font-size: 12px; font-family: monospace"
                        >
                          <div><i class="fad fa-bug me-1"></i>{{ err.message || err }}</div>
                          <div v-if="err.audit" class="fw-bolder mt-1">
                            → {{ err.audit.method || '?' }} (ligne {{ err.audit.line }}<template v-if="err.audit.type">, {{ err.audit.type }}</template>)
                          </div>
                          <div v-if="err.audit && err.audit.expression" class="mt-1 text-warning">
                            ⟦ {{ err.audit.expression }} ⟧
                          </div>
                          <pre
                            v-if="err.stack"
                            class="bg-dark text-light rounded p-2 mt-1 mb-0"
                            style="font-size: 11px; max-height: 200px; overflow: auto"
                          >{{ err.stack }}</pre>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>

            <div>
              <!-- <img :src="uploadRoot + packDetails.pack.insurer.photo" :alt="packDetails.pack.insurer.label" class="mh-50px"> -->
            </div>
            <div class="my-5 fw-bolder">
              <!-- {{ packDetails.pack.insurer.label }} ▪️ {{ packDetails.pack.label }} -->
            </div>
            <div>
              <table class="table table-striped">
                <tbody>
                  <!-- <tr v-for="detail in packDetails.details">
            <td class="p-2">
                {{ detail.name }}
            </td>
            <td class="text-end p-2">
                {{ helper.currencyFormat(detail.value) }}
            </td>
        </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="functionDetail" class="p-5 overflow-auto" style="max-width:560px; word-break:break-word">
          <div class="d-flex justify-content-between align-items-center p-5">
            <h1 class="mb-0">
              {{ functionDetail.insurer }} 🔸 {{ functionDetail.name }}
            </h1>
            <div class="d-flex align-items-center ms-5" style="gap:8px">
              <router-link
                v-if="methodLink(functionDetail)"
                :to="methodLink(functionDetail)"
                target="_blank"
                class="badge badge-light-primary"
              >
                <i class="fad fa-arrow-up-right-from-square me-1"></i>Ouvrir la fonction
              </router-link>
              <div
                class="btn btn-danger btn-xs btn-icon"
                @click="functionDetail = null"
              >
                <i class="fad fa-times"></i>
              </div>
            </div>
          </div>
          <div v-if="functionDetail.error" class="alert alert-danger d-flex flex-column mx-5 mb-5" style="gap:6px">
            <div class="fw-bolder"><i class="fad fa-triangle-exclamation me-2"></i>{{ functionDetail.error }}</div>
            <div v-if="functionDetail.audit" class="d-flex align-items-center flex-wrap" style="gap:8px">
              <span>{{ functionDetail.insurer }} → {{ functionDetail.audit.method }} (Ligne {{ functionDetail.audit.line }}<template v-if="functionDetail.audit.type">, {{ functionDetail.audit.type }}</template>)</span>
            </div>
          </div>
          <!--            <FunctionLineDebugger :detail="detail"  v-for="detail in inlineDetails"/>-->
          <div v-if="isTraceNode(functionDetail)" class="d-flex flex-column px-5" style="gap:4px">
            <div
              v-for="(line, lidx) in functionDetail.inlineDetails"
              :key="'tl_' + lidx"
              class="d-flex align-items-start p-2 rounded"
              :class="(line[0] && line[0].failed) ? 'bg-light-danger' : 'bg-light'"
            >
              <span class="me-2 fw-bolder" :class="(line[0] && line[0].failed) ? 'text-danger' : 'text-success'">{{ line[0] ? line[0].operation : '' }}</span>
              <div class="d-flex flex-column" style="min-width:0">
                <span class="text-muted" style="font-size:11px">{{ line[0] ? line[0].label : '' }}</span>
                <code :class="(line[0] && line[0].failed) ? 'text-danger fw-bolder' : 'text-gray-800'" style="white-space:pre-wrap; word-break:break-word; font-size:12px">{{ line[0] ? line[0].code : '' }}</code>
              </div>
            </div>
          </div>
          <template v-else-if="functionDetail.inlineDetails && functionDetail.inlineDetails.length > 0">
            <div class="d-flex justify-content-end px-5 mb-2">
              <div class="btn btn-sm" :class="showAllCond ? 'btn-light-primary' : 'btn-light'" @click="showAllCond = !showAllCond">
                <i class="fad fa-filter me-1"></i>{{ showAllCond ? trans('Toutes les conditions') : trans('Conditions clés') }}
              </div>
            </div>
            <div v-for="(line, lidx) in functionDetail.inlineDetails" :key="'line_'+lidx" class="d-flex align-items-start py-1 px-5 rounded" :class="lidx % 2 ? 'bg-light' : ''">
              <span v-if="line[0] && line[0].ln" class="badge badge-light-dark me-2 mt-1" style="min-width:34px">L{{ line[0].ln }}</span>
              <div class="flex-grow-1" style="min-width:0">
              <!-- LIGNE CONDITION (if) -->
              <div v-if="line[0] && line[0].cond" class="d-flex flex-wrap align-items-center" style="gap:6px; row-gap:6px">
                <template v-if="showAllCond">
                  <template v-for="(grp, gi) in groupCond(line)">
                    <span v-if="gi > 0" :key="'or'+lidx+'-'+gi" class="badge badge-light-dark fw-bolder">ou</span>
                    <span v-if="grp.length > 1" :key="'lb'+lidx+'-'+gi" class="fs-2 fw-bolder text-muted">[</span>
                    <template v-for="(p, pi) in grp">
                      <span v-if="pi > 0" :key="'and'+lidx+'-'+gi+'-'+pi" class="badge badge-light-info">et</span>
                      <span :key="'p'+lidx+'-'+gi+'-'+pi" class="cond-atom" :class="{flipped: p.flip}">
                        <span class="badge d-flex align-items-center" :class="condClass(p)"><span class="d-flex flex-column align-items-center text-center"><span style="font-size:10px"><i class="fad me-1" :class="condIcon(p)"></i>{{ atomExpected(p) }}</span><span class="cond-bottom" style="font-size:10px"><span class="cond-field">{{ p.cmp }} {{ p.field }}</span><span class="cond-actual">{{ p.cmp }} {{ condActual(p) }}</span></span></span><i class="fad fa-caret-down cursor-pointer" :class="{'fa-rotate-180': p.flip}" @click="$set(p, 'flip', !p.flip)" style="padding:0 6px"></i></span>
                      </span>
                    </template>
                    <span v-if="grp.length > 1" :key="'rb'+lidx+'-'+gi" class="fs-2 fw-bolder text-muted">]</span>
                  </template>
                </template>
                <template v-else>
                  <template v-for="(p, pi) in condAtoms(line)">
                    <span v-if="pi > 0 && lineResult(line) === true" :key="'cc'+pi" class="badge badge-light-info">et</span>
                    <span :key="'cp'+pi" class="cond-atom" :class="{flipped: p.flip}">
                      <span class="badge d-flex align-items-center" :class="condClass(p)"><span class="d-flex flex-column align-items-center text-center"><span style="font-size:10px"><i class="fad me-1" :class="condIcon(p)"></i>{{ atomExpected(p) }}</span><span class="cond-bottom" style="font-size:10px"><span class="cond-field">{{ p.cmp }} {{ p.field }}</span><span class="cond-actual">{{ p.cmp }} {{ condActual(p) }}</span></span></span><i class="fad fa-caret-down cursor-pointer" :class="{'fa-rotate-180': p.flip}" @click="$set(p, 'flip', !p.flip)" style="padding:0 6px"></i></span>
                    </span>
                  </template>
                </template>
              </div>
              <!-- LIGNE NORMALE (formule) -->
              <div v-else class="d-flex align-items-center flex-wrap" style="gap:4px">
                <div v-for="(place, pidx) in line" :key="'pl'+pidx" class="d-flex align-items-center flex-wrap">
                  <div v-if="place.operation" class="mx-2 badge badge-light-info">{{ place.operation }}</div>
                  <div class="d-flex flex-column justify-content-center align-items-center position-relative">
                    <div v-if="place.expression" class="badge badge-secondary" style="white-space:normal; word-break:break-word; max-width:100%">{{ place.expression }}</div>
                    <div v-if="place.sub" class="d-flex flex-wrap">
                      <div v-for="(sub, sidx) in place.sub" :key="'sub'+sidx" class="d-flex flex-column justify-content-center align-items-center">
                        <div class="d-flex justify-content-center">
                          <div v-if="sub.operation" class="mx-2 badge badge-light-info">{{ sub.operation }}</div>
                          <div class="expression-wrapper cursor-pointer">
                            <div :class="{'badge-light-success': sub.value === 'Vrai', 'badge-light-danger': sub.value === 'Faux'}" :title="sub.value" class="badge expression1 w-100">{{ sub.expression }}</div>
                            <div v-if="sub.expression2" :class="{'badge-light-success': sub.value === 'Vrai', 'badge-light-danger': sub.value === 'Faux'}" :title="sub.value" class="badge expression2 w-100">{{ sub.expression2 }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="isNumeric(place.value)" class="badge badge-light-success position-absolute" style="top: calc(100% + 5px)">{{ currency(place.value, false, false) }}</div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </template>
          <div v-else-if="!functionDetail.error" class="p-5 text-muted">
            Aucune ligne tracée pour cette fonction — valeur : {{ isNumeric(functionDetail.value) ? currency(functionDetail.value) : functionDetail.value }}.
          </div>
        </div>
      </div>
    </transition>
  </div>
  <!--  </transition>-->
</template>
<script lang="ts">
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Branch from "@/entity/Branch";
import { helper } from "@/services/Helper";
import Guarantee from "@/entity/Guarantee";
import ResponseGroup from "@/entity/ResponseGroup";
import { mapper } from "@/Utils/Mapper";
import { api } from "@/services/Api";
import Popup from "@/entity/Popup";
import Item from "@/entity/Item";
import Pack from "@/entity/Pack";
import ItemType from "@/entity/ItemType";
import Property from "@/entity/Property";
import Survey from "@/entity/Survey";
import PropertyChoice from "@/entity/PropertyChoice";
import Question from "@/entity/Question";
import Step from "@/entity/Step";
import { auth } from "@/services/Auth";
import FunctionLineDebugger from "@/views/Income/Comparator/FormComponents/FunctionLineDebugger.vue";
import { isItemImplementWorkflow, logTime } from "@/services/ItemFunction";
import store from "@/store";
import Coverage from "@/entity/Coverage";
import Risk from "@/entity/Risk";
import Loading from "@/components/Loading.vue";
import { engineService } from "@/services/calculator/EngineService";
import { ensureSubRgsLoaded } from "@/services/EnsureSubRgsLoaded";
import EngineInputDebugger from "@/views/Income/Avenant/Components/EngineInputDebugger.vue";

@Component({
  components: { Loading, FunctionLineDebugger, EngineInputDebugger },
  computed: {},
  methods: { isItemImplementWorkflow },
})
export default class Comparison extends Vue {
  calculUuid = helper.generateId();
  @Prop() question!: Question;
  @Prop() currentStep!: Step;
  @Inject("comparatorContext") comparatorContext!: () => {
    rg: ResponseGroup;
    branch: Branch;
    form: Survey;
  };

  get rg(): ResponseGroup {
    return this.comparatorContext().rg;
  }
  get branch(): Branch {
    return this.comparatorContext().branch;
  }
  get survey(): Survey {
    return this.comparatorContext().form;
  }
  uploadRoot = api.uploadRoot;
  results: any[] = [];
  oldResults: any[] = [];
  coverages: any[] = [];
  // Garanties depliees par offre, en vue mobile. Repliees par defaut : une quinzaine
  // de lignes par offre sur une vingtaine d'offres ne se lit pas sur un telephone.
  openedMobileGuarantees: Record<string, boolean> = {};
  items: Item[] = [];
  isLoading = false;
  item: any = null;
  invalid = false;
  packs: Pack[] = [];
  allItems: Item[] = [];
  timeout: any = null;
  showComparisonDetails = false;
  showMappedData = false; // affiche le JSON des données envoyées au moteur (debug)
  engineInput: any = null; // snapshot { insurers, items, payload } du dernier calcul
  mappedCopied = false;
  resultDetail: any = null;
  isMobile = false;
  compared = false;
  workflows: any[] = [];
  certificateRemaining = {};
  backendDetails: any[] = [];
  backendPremiumdetails: any[] = [];
  inlineDetails: any[] = [];
  packSelected: any = null;
  eventSource: any = null;
  calculating = false;
  workflow: any = null;
  attestations = {
    green: 0,
    yellow: 0,
    blue: 0,
  };
  requireCertificate = false;
  comparisonResume: any[] = [];
  value = {
    min: 0,
    max: 0,
  };
  ttl: any = null;
  currentItemType: ItemType | null = null;
  statusUpdated = false;
  functionDetail: any = null;
  isCertificateCountLoaded = false;
  insurers: any = null;
  reductionIds = null;
  itemTypes = {};
  optionalMap = {};
  debug = {};
  private currentRunId: number = 0;

  get packDetails() {
    if (this.resultDetail) {
      const match = this.results.find((r: any) => {
        return r.pack.uuid === this.resultDetail.pack.uuid;
      });
      return match;
    }
    return null;
  }

  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  debugDetails(detail) {
    if (detail) {
      this.functionDetail = detail;
    }
  }

  // Vrai uniquement pour le nœud synthétique de secours (trace ✓/✗ : segments avec label/code).
  isTraceNode(d: any): boolean {
    return !!(d && d.inlineDetails && d.inlineDetails[0] && d.inlineDetails[0][0] && d.inlineDetails[0][0].label !== undefined);
  }

  showAllCond = false; // false = seulement les conditions déterminantes, true = toutes
  groupCond(line: any[]): any[][] {
    const g: any[][] = [];
    for (const p of (line || [])) { const i = p.group || 0; (g[i] = g[i] || []).push(p); }
    return g.filter(Boolean);
  }
  condAtoms(line: any[]): any[] {
    for (const grp of this.groupCond(line)) { if (grp.length && grp.every((p: any) => p.value === true)) return grp; }
    return (line || []).filter((p: any) => p.value !== true);
  }
  lineResult(line: any[]): boolean | undefined {
    let undef = false;
    for (const grp of this.groupCond(line)) {
      if (grp.length && grp.every((p: any) => p.value === true)) return true;
      if (grp.some((p: any) => p.value === undefined)) undef = true;
    }
    return undef ? undefined : false;
  }
  condClass(p: any): string {
    return p.value === true ? 'badge-light-success' : p.value === false ? 'badge-light-danger' : 'badge-light-warning';
  }
  condIcon(p: any): string {
    return p.value === true ? 'fa-check' : p.value === false ? 'fa-xmark' : 'fa-question';
  }
  cmpSym(cmp: string): string {
    return cmp === '!==' ? '≠' : cmp === '>=' ? '≥' : cmp === '<=' ? '≤' : cmp === '===' ? '' : cmp;
  }
  atomBig(p: any): string {
    const s = this.cmpSym(p.cmp || '===');
    const exp = (p.expected !== undefined && p.expected !== '') ? p.expected : p.expression;
    return (s ? s + ' ' : '') + exp;
  }
  condActual(p: any): string {
    const v = p.actual;
    if (v === undefined || v === null) return '(non défini)';
    if (typeof v === 'boolean') return v ? 'vrai' : 'faux';
    if (v === '') return '(vide)';
    return String(v);
  }

  // Route vers l'éditeur de la fonction moteur (engine-method-editor) depuis la ligne auditée.
  methodLink(a: any) {
    if (!a || !a.methodId || !a.engineVersion || !this.branch?.slug) return null;
    return {
      name: "engine-method-editor",
      params: {
        engineVersion: String(a.engineVersion),
        branchSlug: String(this.branch.slug),
        methodId: String(a.methodId),
        methodSlug: a.methodCode || a.code || "_",
      },
    };
  }

  /** JSON lisible des données envoyées au moteur (items + payload). */
  get mappedDataJson(): string {
    if (!this.engineInput) {
      return "";
    }
    try {
      return JSON.stringify(this.engineInput, null, 2);
    } catch (e) {
      return "// Sérialisation impossible : " + (e as any)?.message;
    }
  }

  async copyMappedData() {
    try {
      await navigator.clipboard.writeText(this.mappedDataJson);
      this.mappedCopied = true;
      setTimeout(() => (this.mappedCopied = false), 2000);
    } catch (e) {
      // presse-papier indispo (http) -> l'utilisateur copie manuellement depuis le bloc
    }
  }

  isOrderAllowed() {
    if (this.branch && !this.branch.allowOrder) {
      if (auth.isConnected()) {
        new Popup(
          "Attention",
          "La branche " +
            this.branch.label +
            " n'a pas été configurée pour autoriser la génération de devis"
        );
      }
      return false;
    }
    if (this.survey && !this.survey.allowOrder) {
      if (auth.isConnected()) {
        new Popup(
          "Attention",
          "Le formulaire " +
            this.survey.label +
            " n'a pas été configuré pour autoriser la génération de devis"
        );
      }
      return false;
    }
    return true;
  }

  resolveCurrentItemType() {
    if (this.branch && this.branch.items && Array.isArray(this.branch.items)) {
      const itemRef = this.survey.item;
      this.currentItemType = this.branch.items.find((i: ItemType) => {
        return i.uuid === itemRef || i.code === itemRef || String(i.id) === String(itemRef);
      }) || null;
    }
  }

  canSubscribe(coverage: any) {
    if (this.workflows.includes("asaci")) {
      if (coverage?.pack?.code.toLowerCase().includes("test") && auth.hasRole("ROLE_MANAGER")) {
        return true;
      }
      const insurerId = coverage.insurer.id;

      if (!this.certificateRemaining.hasOwnProperty(insurerId)) {
        return false;
      }
      const blue = this.certificateRemaining[insurerId].blue;
      const yellow = this.certificateRemaining[insurerId].yellow;
      const green = this.certificateRemaining[insurerId].green;

      if (this.attestations.blue > 0 && blue < this.attestations.blue) {
        // console.log('blue is missing')
        return false;
      }
      if (this.attestations.yellow > 0 && yellow < this.attestations.yellow) {
        // console.log('yellow is missing required ' + this.attestations.yellow)
        return false;
      }
      if (this.attestations.green > 0 && green < this.attestations.green) {
        // console.log('green is missing')
        return false;
      }
      // console.log('all is ok')
      return true;
    }
    return true;
  }

  unselect() {
    this.packSelected = null;
    this.timeout = setTimeout(this.updateRowHeight, 200);
  }

  checkDesign() {
    const width = document.body.clientWidth;
    this.isMobile = width < 1000;
  }

  getReductionAmount(result: any) {
    let premium = 0;
    result.reductions?.forEach((r: any) => {
      if (r.premium > 0) {
        premium += r.premium;
      }
    });
    return premium;
  }

  getfinalPremium() {
    return;
  }

  showDetails(result: any) {
    // console.log(result)
    this.resultDetail = result;
    // this.loadDebug()
  }

  hideDetails() {
    this.resultDetail = null;
  }

  async mounted() {
    // Vérifier que branch et items existent avant d'accéder
    this.resolveCurrentItemType();
    this.checkDesign();
    this.$addListener(window, "resize", this.checkDesign);
    this.$setTimeout(() => {
      this.updateRowHeight();
    }, 200);
    this.getItemTypes();
    this.getInsurers();

    // Vérifier que les données statiques sont disponibles avant de continuer
    if (!helper.empty(this.itemTypes) && !helper.empty(this.insurers)) {
      await engineService.setStaticData(this.itemTypes, this.insurers);
      this.map();
      this.setPackSelected();
    }
  }

  async loadDebug() {
    const res = await api.get(api.form, "order/debug/" + this.rg.uuid);
    if (res && res.data && res.data.data && res.data.data.data) {
      this.backendDetails = res.data.data.data.details;
      this.backendPremiumdetails = res.data.data.data.premiumDetails;
    }
  }

  async loadCountCertificate() {
    this.requireCertificate = false;
    this.requireCertificate = true;
    const res = await api.get(api.core, "insurer/certificate/list");
    this.certificateRemaining = res.data.remaining;
    this.isCertificateCountLoaded = true;
  }

  setPackSelected() {
    if (this.question.response.value) {
      const data = JSON.parse(this.question.response.value);
      // console.log(data)
      let coverage: Coverage | null = this.coverages.find((c: Coverage) => {
        return c.pack.id === data.pack.id;
      });
      // console.log(result)
      if (coverage) {
        for (let optional of data.optionals) {
          const exist = coverage.risks.find((risk: Risk) => {
            return risk.guarantee.id === optional;
          });

          const opt = coverage.optionalRisks.find((risk: Risk) => {
            return risk.guarantee.id === optional;
          });
          if (!exist && opt) {
            this.toggleOptional(coverage, opt.guarantee);
            // console.log('toggle ', exist.guarantee.label)
          }
        }
        coverage = this.coverages.find((c: Coverage) => {
          return c.pack.id === data.pack.id;
        });
        if (coverage) {
          this.packSelected = coverage;
          return coverage;
        }
      }
    }
    this.packSelected = null;
    return null;
  }

  async subscribe(coverage: any) {
    // console.log(result)
    // return
    this.$store.commit("loading");
    const data = {
      pack: coverage.pack.id,
      risks: Object.keys(coverage.risks).map(Number),
    };
    const rep = {
      questionId: this.question.id,
      rgUuid: this.rg.uuid,
      value: JSON.stringify(data),
    };

    const res = await api.post(api.form, "api/make/order/" + this.rg.uuid, {
      response: rep,
    });
    this.$store.commit("stopLoading");
    if (res && res.data && res.data.order) {
      if (!this.currentItemType) this.resolveCurrentItemType();
      if (this.currentItemType && this.currentItemType!.isRoot) {
        const ct = store.getters.currentTenant();
        this.$router.push({name: "order-view", params: { uuid: res.data.order },query : { zone : ct?.code }});
      }
    }
    return;

    // const responses = JSON.parse(JSON.stringify([rep]));
    // const r = await api.post(api.form, "api/save/responses", responses);
    // this.$store.commit('stopLoading')

    // if (r?.data?.responses) {
    //   this.setPackSelected()
    //   if (this.isOrderAllowed()) {
    //     this.$store.commit('loading')
    //     const res = await api.get(api.form, 'api/make/order/' + this.rg.uuid)
    //     this.$store.commit('stopLoading')
    //     if (res && res.data && res.data.order) {
    //       this.$store.commit('appendOrder', res.data.order)
    //       if (this.currentItemType && this.currentItemType!.isRoot) {
    //         this.$router.push({name: 'order-view', params: {uuid: res.data.order.uuid}});
    //       }
    //     }
    //   }
    // } else {
    //   new Popup("Erreur", "Une erreur est arrivé lors de la section de l'offre", "danger")
    // }
    // this.$store.commit('stopLoading')
  }

  isLastStep() {
    let currentRanking = this.currentStep.ranking + 1;
    for (let step of this.survey.steps) {
      if (step.ranking > currentRanking) {
        if (step.isVisible()) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("$store.state.mainStore.rgStatus")
  map() {
    // console.log('recalculate rgStatus updated')
    this.compare();
  }

  getDuree() {
    const avenant: Item = this.items.find((i: Item) => {
      return i.model.code === "avenant";
    }) as any;
    if (avenant instanceof Item) {
      const prop = avenant.getPropertyByCode("duree");
      const choice = prop.model.choices.find((c: PropertyChoice) => {
        return c.code === prop.value;
      });
      return choice ? choice.label : "";
    }
  }

  resetAttestationsRequirements() {
    this.attestations = {
      green: 0,
      yellow: 0,
      blue: 0,
    };
  }

  getInsurers() {
    if (!helper.empty(this.insurers)) {
      return this.insurers;
    }
    const comparatorInsurers = Object.values(store.state.comparatorStore?.insurers || {});
    const src =
      comparatorInsurers.length > 0 ? comparatorInsurers :
      store.state.mainStore.insurers ??
      store.state.contractStore?.insurers ??
      [];

    this.insurers = {};
    if (Array.isArray(src)) {
      for (const i of src) {
        if (i && i.id) {
          this.insurers[i.id] = i;
        }
      }
    }

    return this.insurers;
  }

  getReductionIds() {
    if (this.reductionIds && this.reductionIds.length > 0) {
      return this.reductionIds;
    }
    if (!Array.isArray(this.reductionIds)) {
      this.reductionIds = [];
    }

    const toArray = (v: any) => !v ? [] : Array.isArray(v) ? v : Object.values(v);
    const currentBranch = this.branch;
    if (currentBranch && currentBranch.reductionModels) {
      toArray(currentBranch.reductionModels).forEach((rm: any) => {
        if (rm.isEnable) {
          this.reductionIds.push(rm.id);
        }
      });
    }
    return this.reductionIds;
  }

  getItemTypes() {
    if (!helper.empty(this.itemTypes)) return this.itemTypes;

    // Utiliser la branch du comparatorContext
    const currentBranch = this.branch;
    if (!currentBranch || !currentBranch.items) {
      return this.itemTypes;
    }

    const toArr = (v: any) => !v ? [] : Array.isArray(v) ? v : Object.values(v);
    toArr(currentBranch.items).forEach((i: ItemType) => {
      if (i.workflows) {
        toArr(i.workflows).forEach((w: any) => {
          const code = (typeof w === 'string' ? w : w.code || '').toLowerCase();
          if (code && !this.workflows.includes(code)) {
            this.workflows.push(code);
          }
        });
      }
      const model = JSON.parse(JSON.stringify(i));
      model.properties = {};
      toArr(i.properties).forEach((prop: any) => {
        model.properties[prop.code] = prop;
      });
      this.$set(this.itemTypes, i.code, model);
    });

    // console.log(JSON.stringify(this.workflows))
    // console.log(this.workflows.includes("asaci"))
    if (this.workflows.includes("asaci")) {
      // console.log('load certificates')
       this.loadCountCertificate();
    }


    return this.itemTypes;
  }

  async compare(
    partial = false,
    { packRestrictions = [] }: { packRestrictions?: any[] } = {}
  ) {
    if (!partial) {
      this.coverages = [];
      this.debug = [];
    }
    for (const step of this.survey.steps) {
      if (step.ranking < this.currentStep.ranking) {
        step.validate();
        if (!step.isValid) {
          return;
          return;
        }
      }
    }

    this.invalid = false;
    this.calculating = true;
    this.resetAttestationsRequirements();

    // logTime("Comparaison", true);

    let setStatic = false;
    if (helper.empty(this.reductionIds)) {
      this.getReductionIds();
    }
    if (helper.empty(this.itemTypes)) {
      setStatic = true;
      this.getItemTypes();
    }
    if (helper.empty(this.insurers)) {
      setStatic = true;
      this.getInsurers();
    }

    if (helper.empty(this.itemTypes)) {
      return;
    }
    if (helper.empty(this.insurers)) {
      return;
    }
    if (!engineService.isEngineLoaded) {
      return;
    }
    // Le calcul de prime a besoin du graphe RG complet — on hydrate les
    // sous-RG encore en stub avant d'appeler le mapper.
    await ensureSubRgsLoaded(this.rg);
    const mapped = mapper.map(this.rg, this.itemTypes);
    console.log(JSON.parse(JSON.stringify(mapped.items)))
    // return
    // console.log('[Comparison] categories:', mapped.categories)
    if (setStatic) {
      // console.log('Static Data not set ... setting')
      await engineService.setStaticData(this.itemTypes, this.insurers);
    }
    const reductionIds = this.getReductionIds();
    const payload = {
      required: mapped.required,
      itemUuid: mapped.itemUuid,
      assetUuids: mapped.assetUuids,
      method: "computeVehicle",
      reductions: reductionIds,
      workflows: mapped.workflows,
      packCategories: mapper.categories,
      packRestrictions: packRestrictions,
      debug: !!auth.hasRole("ROLE_MANAGER"),
      // Audit ligne-par-ligne RESERVE ROLE_MANAGER : pointe la ligne fautive quand une méthode throw.
      audit: !!auth.hasRole("ROLE_MANAGER"),
      optionalMap: this.optionalMap,
    };
    this.workflow = mapper.workflow;
    this.attestations = mapper.attestations;
    // Snapshot des données réellement envoyées au moteur (debug ROLE_MANAGER, bouton « Données mappées »).
    this.engineInput = {
      insurers: Object.keys(this.insurers),
      items: mapped.items,
      payload,
    };
    await engineService.setItems(mapped.items);

    try {
    await engineService.calculate(
      Object.keys(this.insurers),
      payload,
      (coverage) => {
        const insurer = this.insurers[coverage.insurerId];
        if (!insurer) {
          // console.warn('[Comparison] coverage for unknown insurer:', coverage.insurerId);
          return;
        }
        const pack: Pack = insurer.packs.find((p) => {
          return p.code === coverage.pack;
        });
        if (!pack) {
          // console.warn('[Comparison] coverage for unknown pack:', coverage.pack, 'insurer:', insurer.label);
          return;
        }
        // console.log('[Comparison] coverage:', insurer.label, pack.code, 'premium:', coverage.premium, 'errors:', coverage.errors?.length || 0);
        this.$set(this.debug, insurer.id, this.debug[insurer.id] || {});
        this.$set(this.debug[insurer.id], pack.id, {
          details: coverage.details,
          errors: coverage.errors,
          premium: coverage.premium,
        });
        delete coverage.details;
        delete coverage.errors;
        if (coverage.premium > 0) {
          coverage.reductionAmount = 0;
          Object.values(coverage.reductions).forEach((r: any) => {
            coverage.reductionAmount += r;
          });
          coverage.insurer = {
            id: insurer.id,
            photo: insurer.photo,
            label: insurer.label,
            slug: insurer.slug,
          };
          coverage.pack = {
            uuid: pack.uuid,
            id: pack.id,
            label: pack.label,
            code: pack.code,
          };
          coverage.category = {
            id: pack.category.id,
            label: pack.category.label,
            slug: pack.category.slug,
          };
          const index = this.coverages.findIndex((c) => {
            return c.pack.id === coverage.pack.id;
          });
          if (index === -1) {
            this.coverages.push(coverage);
          } else {
            this.$set(this.coverages, index, coverage);
          }
        }
      }
    );
    } catch (e: any) {
      console.error('[Comparison] engine error:', e.message || e);
    }
    this.coverages.sort((a: any, b: any) => {
      return a.premium - b.premium;
    });
    if (partial && packRestrictions.length > 0) {
      this.scrollToCoverage(packRestrictions[0]);
    }
    // logTime("Comparison End ...");
  }

  scrollToCoverage(coverageId: number | string) {
    this.$nextTick(() => {
      const scroller = document.getElementById("scroller");
      const target = document.getElementById("coverage-header-" + coverageId);
      // const columns = document.querySelectorAll('.coverage-column-' + coverageId)
      if (!scroller || !target) return;
      const scrollerWidth = scroller.clientWidth;
      const scrollWidth = scroller.scrollWidth;
      const targetRect = target.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();

      const targetOffsetLeft =
        targetRect.left - scrollerRect.left + scroller.scrollLeft;

      let scrollLeft =
        targetOffsetLeft - scrollerWidth / 2 + target.offsetWidth / 2;

      if (scrollLeft < 0) scrollLeft = 0;
      if (scrollLeft > scrollWidth - scrollerWidth)
        scrollLeft = scrollWidth - scrollerWidth;

      scroller.scrollTo({ left: scrollLeft, behavior: "smooth" });

      target.classList.add("bg-light-primary");
      // columns.forEach((c:any)=>{
      //   c.classList.add('bg-light-primary')
      // })
      setTimeout(() => {
        target.classList.remove("bg-light-primary");
        // columns.forEach((c:any)=>{
        //   c.classList.remove('bg-light-primary')
        // })
      }, 500);
    });
  }

  updateStatus() {
    if (!this.statusUpdated) {
      this.statusUpdated = true;
      clearTimeout(this.ttl);
      api.post(api.form, "api/compare/" + this.rg.uuid, { value: this.value });
    }
  }

  replaceChild(item: Item, child: Item) {
    // console.log('on fouille ' + item.name)
    item.properties.forEach((p: Property) => {
      p.children.forEach((c: Item, index) => {
        if (c.uuid === child.uuid) {
          // console.log('on a trouve ' + child.name)
          p.children[index] = child;
        }
        this.replaceChild(c, child);
      });
    });
  }

  getPackPremium(coverage: Coverage) {
    let premium = coverage.premium;
    return premium;
  }

  getOptionalPremium(result: any, guarantee: Guarantee) {
    const match = result.optionals.find((o: any) => {
      if (guarantee.method) {
        return o.code === guarantee.method.code;
      }
    });
    return match;
  }

  async toggleOptional(coverage: any, guarantee: Guarantee) {
    if (!this.optionalMap.hasOwnProperty(coverage.pack.id)) {
      this.optionalMap[coverage.pack.id] = [];
    }

    const idx = this.optionalMap[coverage.pack.id].indexOf(guarantee.id);
    if (idx !== -1) {
      this.optionalMap[coverage.pack.id].splice(idx, 1);
    } else {
      this.optionalMap[coverage.pack.id].push(guarantee.id);
    }
    const result: any = await this.compare(true, {
      packRestrictions: [coverage.pack.id],
    });
  }

  replaceEngineItemConverted(engine: any, itemConverted: any) {
    let item: Item = itemConverted.item;
    // console.log('on veu remplacer ' + item.name + ' ' + item.uuid)
    const entities = Object.keys(engine);
    entities.forEach((k: string) => {
      // console.log('on check la proprieté ' + k)
      const entity = engine[k];
      if (entity.item) {
        // console.log(entity.item.uuid + ' === ' + item.uuid)
        // console.log(entity)
        if (item.uuid === entity.item.uuid) {
          // console.log('replace main object ' + entity.item.name)
          engine[k].item = item;
        }

        this.replaceChild(entity.item, item);
      }
      // console.log(entity)
      // const itemProps = Object.keys(entity)
    });
  }

  loadEngine() {}

  updated(): void {
    this.timeout = setTimeout(this.updateRowHeight, 200);
  }

  updateRowHeight() {
    clearTimeout(this.timeout);
    this.timeout = null;
    try {
      const offers = document.querySelectorAll(".offers");
      offers.forEach((offer: any) => {
        const heads = offer.querySelectorAll(".offers th");

        const rows = offer.querySelectorAll(".offers .results tbody tr");
        const equiRows = offer.querySelectorAll(".offers .guarantee tbody tr");
        let max = 0;
        heads.forEach((g: HTMLElement) => {
          g.style.height = "auto";
          if (g.getBoundingClientRect().height > max) {
            max = g.getBoundingClientRect().height;
          }
        });
        heads.forEach((head: HTMLElement) => {
          head.style.height = max + "px";
        });

        rows.forEach((row: HTMLElement, rowIndex: number) => {
          max = 0;
          const columns = row.querySelectorAll("td");
          columns.forEach((column: HTMLElement) => {
            column.style.height = "auto";
            if (column.getBoundingClientRect().height > max) {
              max = column.getBoundingClientRect().height;
            }
          });
          const equiRow = equiRows[rowIndex];
          const equiCol = equiRow.querySelectorAll("td");

          equiCol.forEach((ec: HTMLElement) => {
            if (ec.getBoundingClientRect().height > max) {
              max = ec.getBoundingClientRect().height;
            }
          });

          columns.forEach((column: HTMLElement) => {
            column.style.height = max + "px";
          });

          equiCol.forEach((ec: HTMLElement) => {
            ec.style.height = max + "px";
          });
        });
      });
    } catch (e) {}
  }

  toggleMobileGuarantees(coverage: any) {
    const key = String(coverage?.pack?.id);
    this.$set(this.openedMobileGuarantees, key, !this.openedMobileGuarantees[key]);
  }

  isMobileGuaranteesOpen(coverage: any): boolean {
    return !!this.openedMobileGuarantees[String(coverage?.pack?.id)];
  }

  /** Garanties acquises sur cette offre : incluses d'office ou optionnelles retenues. */
  countIncluded(coverage: any): number {
    return Object.keys(coverage?.risks || {}).length;
  }

  /** Garanties encore proposees en option, donc pas encore payees. */
  countOptional(coverage: any): number {
    return Object.keys(coverage?.optionalRisks || {}).length;
  }

    onePackHasGuarantee(guarantee: Guarantee) {
    if (this.coverages.length === 0) {
      return false;
    }
    for (let coverage of this.coverages) {
      if (coverage.risks && coverage.risks.hasOwnProperty(guarantee.id)) {
        return true;
      }
    }
    return false;
  }

  allPackHasGuarantee(guarantee: Guarantee, pack: Pack) {
    for (let coverage of this.coverages) {
      if (!coverage.risks.hasOwnProperty(guarantee.id)) {
        return false;
      }
    }
    return true;
  }
}
</script>
<style scoped>
.mapped-json {
  max-width: 500px;
  max-height: 60vh;
  overflow: auto;
  background: #1e1e2d;
  color: #d6d9e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 11px;
  line-height: 1.5;
  white-space: pre;
  user-select: text;
  margin: 0;
}

.accordion {
  max-height: 0;
  overflow: hidden;
}

.checkbox-accordion {
  display: none;
}

.checkbox-accordion:checked ~ .accordion {
  max-height: none;
}

.checkbox-accordion:checked ~ label .fa-caret-right {
  display: none;
}

.checkbox-accordion:not(:checked) ~ label .fa-caret-down {
  display: none;
}

.offers tbody tr:nth-child(2n + 1) {
  background: rgba(61, 218, 215, 0.21);
}

.results td,
.results th {
  min-width: 200px;
}

.results-container {
  position: relative;
  /*border: 1px red solid;*/
}

.results-container:before,
.results-container:after {
  content: "";
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 0;
  /*background: rgb(2,0,36);*/
  background: linear-gradient(
    -90deg,
    rgba(2, 0, 36, 0) 0%,
    rgba(255, 255, 255, 1) 75%
  );
}

.results-container:after {
  left: auto;
  right: 0;
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 0) 0%,
    rgba(255, 255, 255, 1) 75%
  );
}

.results td {
  border-right: 10px white solid;
  /*background: rgba(255, 255, 255, 0.21);*/
}

.expression-wrapper {
  position: relative;
  width: max-content;
  /* ou fixe */
  overflow: visible;
}

/* Premier div visible par défaut */
.expression1 {
  position: relative;
  z-index: 1;
  transition: opacity 0.3s ease;
}

/* Deuxième div caché, positionné au-dessus */
.expression2 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0;
  transform: translateY(20px);
  /* décalage initial pour glisser */
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  /* Pour ne pas gêner le hover */
}

/* Au hover sur le wrapper : on fait glisser le 2e div par-dessus */
.expression-wrapper:hover .expression2 {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

/* Optionnel : on peut faire disparaître le premier pendant le hover */
.expression-wrapper:hover .expression1 {
  opacity: 0.3;
}
/* Condition : le caret fait glisser le bas (champ <-> vraie valeur). */
.cond-atom {
  position: relative;
  width: max-content;
  display: inline-block;
}
.cond-bottom {
  position: relative;
  display: block;
  overflow: visible;
  white-space: nowrap;
}
.cond-field,
.cond-actual {
  display: block;
  transition: transform 0.2s ease, opacity 0.2s ease;
  white-space: nowrap;
}
.cond-actual {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translateY(100%);
}
.cond-atom.flipped .cond-field {
  opacity: 0;
  transform: translateY(-100%);
}
.cond-atom.flipped .cond-actual {
  opacity: 1;
  transform: translateY(0);
}
</style>

<style scoped>
/* --- VUE MOBILE DES OFFRES --- */
.mobile-offers {
  padding: 12px 10px 24px;
}

.mo-card {
  background: white;
  border: 1px solid #e4e6ef;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 4px 14px rgba(24, 28, 50, 0.06);
}

.mo-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mo-logo {
  max-height: 40px;
  max-width: 90px;
  object-fit: contain;
}

.mo-ident {
  flex: 1;
  min-width: 0;
}

.mo-insurer {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #7e8299;
}

.mo-pack {
  font-size: 15px;
  font-weight: 700;
  color: #181c32;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mo-price {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.mo-old {
  font-size: 14px;
  font-weight: 700;
  color: #f1416c;
  text-decoration: line-through;
}

.mo-amount {
  font-size: 26px;
  font-weight: 800;
  color: #00cdd5;
  line-height: 1.1;
}

.mo-period {
  font-size: 13px;
  font-weight: 600;
  color: #7e8299;
}

.mo-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 9px 12px;
  border-radius: 10px;
  background: #f9fafc;
  border: 1px solid #f1f3f8;
  font-size: 12.5px;
  font-weight: 600;
  color: #5e6278;
  cursor: pointer;
}

.mo-guarantees {
  margin-top: 8px;
  border-top: 1px dashed #e4e6ef;
  padding-top: 8px;
}

.mo-g {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 2px;
  font-size: 13px;
  border-bottom: 1px solid #f6f7fb;
}

.mo-g:last-child {
  border-bottom: 0;
}

.mo-g-label {
  flex: 1;
  min-width: 0;
  color: #181c32;
}

.mo-g-note {
  font-size: 11px;
  font-weight: 600;
  color: #a1a5b7;
  white-space: nowrap;
}

.mo-g--in i {
  color: #50cd89;
}

.mo-g--opt {
  cursor: pointer;
}

.mo-g--opt i {
  color: #00cdd5;
}

.mo-g-price {
  font-weight: 700;
  color: #00cdd5;
  white-space: nowrap;
}

.mo-g--out i {
  color: #d6d8e1;
}

.mo-g--out .mo-g-label {
  color: #a1a5b7;
}

.mo-actions {
  margin-top: 14px;
}
</style>
